export const GET_DETAIL_BY_PRODUCT = "GET_DETAIL_BY_PRODUCT";
